export class ClientPatronageStageUpdatedCSEvent {
  static type = 'ClientPatronageStageUpdated';
  get type() {
    return ClientPatronageStageUpdatedCSEvent.type;
  }

  constructor(readonly clientId: number) {}
}
